import React from 'react'
import EasingBox from 'lib/components/charts/shapes/easing-box'
import SelectedLink from 'lib/components/selected-link'

class SBIEasingBox extends React.PureComponent {
  render() {
    const { category, id, label } = this.props

    return (
      <SelectedLink
        category={category}
        selected={id}
        track={label}
        trackAs="chart-item"
        avoidHref={true}
      >
        <EasingBox {...this.props} />
      </SelectedLink>
    )
  }
}

export default SBIEasingBox



// WEBPACK FOOTER //
// ./src/components/charts/shapes/easing-box.js